import { getRegistry } from './getRegistry'

export const applyPlugins = (editor) => {
    const plugins = getRegistry('v2.plugin');
    for (let plugin in plugins) {
        const { component } = plugins[plugin]['components'][0]
        editor = component(editor);
    }
    return editor
}